import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { configuration } from "properties/config";


@Injectable({
    providedIn: 'root',
})
export class StorageService {

    constructor(
        private readonly cookieService: CookieService
    ) { }

    memoryStorage: Map<string, any> = new Map<string, any>();

    storeObject = (key: string, value: any, storageLocation: any = configuration.storageTypes.SessionStorage): void => {
        switch (storageLocation) {
            case configuration.storageTypes.InMemory:
                this.memoryStorage.set(key, value);
                break;

            case configuration.storageTypes.LocalStorage:{
                const localObj = JSON.stringify(value);
                localStorage.setItem(key, localObj);
                break;
            }

            case configuration.storageTypes.SessionStorage:{
                const sessionObj = JSON.stringify(value);
                sessionStorage.setItem(key, sessionObj);
                break;
            }

            default:
                break;
        }
    };

    removeObject = (key: string, storageLocation: any = configuration.storageTypes.SessionStorage): void => {
        switch (storageLocation) {
            case configuration.storageTypes.InMemory:
                if (this.memoryStorage.has(key)) {
                    this.memoryStorage.delete(key);
                }
                break;

            case configuration.storageTypes.LocalStorage:
                if (localStorage.getItem(key) !== null) {
                    localStorage.removeItem(key);
                }
                break;

            case configuration.storageTypes.SessionStorage:
                if (sessionStorage.getItem(key) !== null) {
                    sessionStorage.removeItem(key);
                }
                break;

            default:
                break;
        }
    };

    getObject = (key: string, storageLocation: string = configuration.storageTypes.SessionStorage): any  => {
        switch (storageLocation) {

            case configuration.storageTypes.InMemory:
                return (this.memoryStorage.has(key)) ? this.memoryStorage.get(key) : null;

            case configuration.storageTypes.LocalStorage: {
                const object = localStorage.getItem(key);
                return object ? JSON.parse(object) : null;
            }

            case configuration.storageTypes.SessionStorage: {
                const object = sessionStorage.getItem(key);
                return object ? JSON.parse(object) : null;
            }

            default:
                return null;
        }
    };

    hasObject = (key: string, storageLocation: string = configuration.storageTypes.SessionStorage): boolean => {
        switch (storageLocation) {
            case configuration.storageTypes.InMemory:
                return ((key !== undefined && key != null && key !== '') && this.memoryStorage.has(key));

            case configuration.storageTypes.LocalStorage:
                return ((key !== undefined && key != null && key !== '') && localStorage.getItem(key) !== null);

            case configuration.storageTypes.SessionStorage:
                return ((key !== undefined && key != null && key !== '') && sessionStorage.getItem(key) !== null);

            default:
                return false;
        }
    };

    /**
     * Clears all storage objects
     * Cookies are cleared by the server during logout
     */
    clearAllObjects = () => {
        this.memoryStorage.clear();
        localStorage.clear();
        sessionStorage.clear();
    };

    setCookie(key: string, value: any, expires: number | undefined = undefined, path = '/') {

        const expiryDate = new Date();
        if (expires != undefined) {
            expiryDate.setSeconds(expiryDate.getSeconds() + expires);
        }

        this.cookieService.set(key, value, {
            path,
            secure: true,
            sameSite: 'Lax',
            expires: expiryDate
        });
    }

    getCookie(key: string): any {
        return this.cookieService.get(key);
    }

    hasCookie(key: string): boolean {
        return this.cookieService.check(key);
    }

    clearCookie(key: string, path = '/') {
        this.cookieService.delete(key, path);
    }
}